/* =========================================================
   GLOBAL MENU FUNCTIONS
========================================================= */

function myToggleSiteMenu() {
    var element = document.getElementById('navOverlay');

    if (element) {
        element.classList.toggle('showMe');
    }
}

function closeSiteNav() {
    myToggleSiteMenu();
}

function myToggleMenu() {
    var element = document.getElementById('toggleMenu');

    if (element) {
        element.classList.toggle('showToggleMenu');
    }
}


/* =========================================================
   MAIN INITIALIZATION
========================================================= */

(function ($) {
    'use strict';

    $(function () {

        var windowWidth = window.innerWidth || document.documentElement.clientWidth;
        var isMobile980 = windowWidth <= 980;
        var isMobile990 = windowWidth <= 990;
        var isMobile992 = windowWidth <= 992;
        var isMobile767 = windowWidth <= 767;


        /* =====================================================
           HOME HERO SLIDER
        ===================================================== */

        var homeSliderElement = document.querySelector('.homeSlider');

        if (
            homeSliderElement &&
            typeof Swiper !== 'undefined'
        ) {

            var galleryTop = new Swiper('.homeSlider', {
                spaceBetween: 0,
                loop: true,

                pagination: {
                    el: '.swiper-paginationhome',
                    clickable: true
                },

                navigation: {
                    nextEl: '.swiper-button-home-next',
                    prevEl: '.swiper-button-home-prev'
                },

                breakpoints: {
                    990: {
                        slidesPerView: 1,
                        slidesPerGroup: 1
                    }
                }
            });


            /*
             * Change pagination color on 4th slide
             */
            galleryTop.on('slideChangeTransitionEnd', function () {

                var activeIndex = this.realIndex;

                var bullets = document.querySelectorAll(
                    '.swiper-paginationhome .swiper-pagination-bullet'
                );

                if (!bullets.length) {
                    return;
                }

                bullets.forEach(function (bullet) {

                    bullet.style.backgroundColor =
                        activeIndex === 3 ? 'black' : 'white';

                });

            });
        }


        /* =====================================================
           KEEP EXPLORING SLIDER
        ===================================================== */

        var exploreSliderElement = document.querySelector('.swiper-container');

        if (
            exploreSliderElement &&
            typeof Swiper !== 'undefined'
        ) {

            new Swiper('.swiper-container', {

                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 8,

                loopFillGroupWithBlank: false,
                loop: false,

                lazy: {
                    loadPrevNext: true
                },

                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },

                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },

                breakpoints: {

                    0: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        spaceBetween: 4
                    },

                    768: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        spaceBetween: 4
                    },

                    990: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                        spaceBetween: 6
                    }

                }

            });

        }


        /* =====================================================
           HOME MIDDLE SLIDER
        ===================================================== */

        var middleSliderElement =
            document.querySelector('.homeMiddleSection');

        if (
            middleSliderElement &&
            typeof Swiper !== 'undefined'
        ) {

            new Swiper('.homeMiddleSection', {

                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 8,

                loopFillGroupWithBlank: false,
                loop: false,

                lazy: {
                    loadPrevNext: true
                },

                pagination: {
                    el: '.swiper-pagination-middle',
                    clickable: true
                },

                navigation: {
                    nextEl: '.middle-button-next',
                    prevEl: '.middle-button-prev'
                },

                breakpoints: {

                    0: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        spaceBetween: 6
                    },

                    768: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        spaceBetween: 6
                    },

                    990: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                        spaceBetween: 6
                    }

                }

            });

        }


        /* =====================================================
           MOBILE NAVIGATION
        ===================================================== */

        if (isMobile992) {

            /*
             * Stop navigation wrapper click bubbling
             * Previously this listener existed multiple times.
             */
            $('.navication')
                .off('click.customNav')
                .on('click.customNav', function (event) {
                    event.stopPropagation();
                });


            /*
             * Main navigation dropdown
             */
            $('nav ul li a.mainLinks')
                .off('click.customMainLinks')
                .on('click.customMainLinks', function () {

                    var $this = $(this);
                    var $next = $this.next();

                    if (!$next.length) {
                        return;
                    }

                    if ($next.hasClass('showdrop')) {

                        $next
                            .removeClass('showdrop')
                            .stop(true, true)
                            .slideUp(350);

                    } else {

                        $this
                            .parent()
                            .parent()
                            .find('.megamenuWapper')
                            .removeClass('showdrop')
                            .stop(true, true)
                            .slideUp(350);

                        $next
                            .addClass('showdrop')
                            .stop(true, true)
                            .slideDown(350);
                    }

                });

        }


        /* =====================================================
           MOBILE NAV <= 980
        ===================================================== */

        if (isMobile980) {

            $('.btnNavToggle, .navTitle .btnNavToggleNew')
                .off('click.customSubMenu')
                .on('click.customSubMenu', function () {

                    $('.subMenu').removeClass('showDropDown');

                });


            $('nav .navication .mainTitle')
                .off('click.customMainTitle')
                .on('click.customMainTitle', function () {

                    $('.subMenu').removeClass('showDropDown');

                });


            $('.mainNavList > li > a')
                .off('click.customMobileDropdown')
                .on('click.customMobileDropdown', function () {

                    var $this = $(this);
                    var $next = $this.next();

                    if (!$next.length) {
                        return;
                    }

                    if ($next.hasClass('showdrop')) {

                        $next
                            .removeClass('showdrop')
                            .stop(true, true)
                            .slideUp(350);

                    } else {

                        $this
                            .parent()
                            .parent()
                            .find('.megamenuWapper')
                            .removeClass('showdrop')
                            .stop(true, true)
                            .slideUp(350);

                        $next
                            .addClass('showdrop')
                            .stop(true, true)
                            .slideDown(350);
                    }

                });


            $('.navCatList li a')
                .off('click.customNavCat')
                .on('click.customNavCat', function () {

                    $(this)
                        .next('.navCatChildList')
                        .toggleClass('showSubcategery');

                });


            $('.closeDropdown, .btnNavToggle')
                .off('click.customCloseCategory')
                .on('click.customCloseCategory', function () {

                    $('.navCatChildList')
                        .removeClass('showSubcategery');

                });

        }


        /* =====================================================
           MAIN MOBILE MENU OPEN / CLOSE
        ===================================================== */

        $('.toggleMenu, .mainNavHeader .closeMe')
            .off('click.customMainMenu')
            .on('click.customMainMenu', function () {

                $('body').toggleClass('showMainNav');

            });


        /*
         * IMPORTANT:
         * Previously this handler was created INSIDE the menu
         * click event. Every menu open added another click listener.
         *
         * Now it is attached only once.
         */
        if (isMobile990) {

            $('.mainNavList > .ddYes .toggleSubMenu')
                .off('click.customToggleSubMenu')
                .on('click.customToggleSubMenu', function (e) {

                    var $item = $(this).closest('li');

                    if (!$item.hasClass('show')) {

                        $('.mainNavList > li')
                            .removeClass('show');

                        $item.addClass('show');

                    } else {

                        $item.removeClass('show');

                    }

                    e.preventDefault();

                });


            /* =================================================
               MEGA MENU OVERLAY CLOSE

               OLD:
               $('*').on('click', ...)

               NEW:
               One delegated listener only.
            ================================================= */

            $(document)
                .off('click.customMegaMenu')
                .on(
                    'click.customMegaMenu',
                    '.megamenuWapper.showMegamenu',
                    function (e) {

                        if (e.target !== this) {
                            return;
                        }

                        $(this)
                            .removeClass('showMegamenu');

                        $('body')
                            .removeClass('mobScrollNone');

                    }
                );


            /* =================================================
               SWIPE SUPPORT
            ================================================= */

            if (
                $.fn.swipe &&
                $('.megamenuWapper').length
            ) {

                $('.megamenuWapper').swipe({

                    swipeLeft: function () {

                        $(this)
                            .removeClass('showMegamenu');

                        $('body')
                            .removeClass('mobScrollNone');

                    }

                });

            }


            /* =================================================
               ROLEX MOBILE NAVIGATION
            ================================================= */

            $('.rolexNavList > li.dropDownclick > a')
                .off('click.customRolexNav')
                .on('click.customRolexNav', function () {

                    $('.dropdown-menu')
                        .toggleClass('showNav');

                });

        }


        /* =====================================================
           BACK TO TOP
        ===================================================== */

        $('.bottomTop')
            .off('click.customBackToTop')
            .on('click.customBackToTop', function (e) {

                e.preventDefault();

                $('html, body')
                    .stop(true)
                    .animate(
                        {
                            scrollTop: 0
                        },
                        500
                    );

            });


        /* =====================================================
           INFO BAR
        ===================================================== */

        $('.closeInfoBar')
            .off('click.customInfoBar')
            .on('click.customInfoBar', function () {

                $('.headerInfoBar')
                    .stop(true, true)
                    .slideToggle('slow');

            });


        /* =====================================================
           COVID / HEADER MESSAGE
        ===================================================== */

        $('.cross-icon')
            .off('click.customHeaderCovid')
            .on('click.customHeaderCovid', function () {

                $('.headerCovid')
                    .stop(true, true)
                    .slideUp();

            });


        /* =====================================================
           BOOK APPOINTMENT
        ===================================================== */

        $('#bookAnappointment .homeContactBlock label')
            .off('click.customAppointment')
            .on('click.customAppointment', function () {

                $('#bookAnappointment.tab-pane')
                    .removeClass('active');

                $('#please-note')
                    .addClass('active show');

            });


        /* =====================================================
           MOBILE FOOTER ACCORDION
        ===================================================== */

        if (isMobile767) {

            $('.mobAcc')
                .off('click.customFooterAccordion')
                .on('click.customFooterAccordion', function () {

                    var $this = $(this);
                    var $content = $this.siblings('.ftpNav');

                    if ($this.hasClass('active')) {

                        $this.removeClass('active');

                        $content
                            .stop(true, true)
                            .slideUp(200);

                    } else {

                        $('.mobAcc')
                            .removeClass('active');

                        $('.ftpNav')
                            .stop(true, true)
                            .slideUp(200);

                        $this.addClass('active');

                        $content
                            .stop(true, true)
                            .slideDown(200);
                    }

                });

        }

    });

})(jQuery);